import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContextSearch12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconContextSearch12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 1.5a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 0-1H1.5a.5.5 0 0 0-.5.5m0 8a.5.5 0 0 0 .5.5H4a.5.5 0 0 0 0-1H1.5a.5.5 0 0 0-.5.5m8.256-2.872a1.628 1.628 0 1 1-3.256 0 1.628 1.628 0 0 1 3.256 0m1 0c0 .547-.167 1.054-.452 1.475l.05.043 1 1a.5.5 0 0 1-.708.708l-1-1-.043-.05a2.628 2.628 0 1 1 1.153-2.176M1.5 6a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContextSearch12);
